import React from "react";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { Typography } from "@mui/material";
import { REPORT_URL } from "../../utils/environmentVariables";

import buildUrl from "build-url-ts";

const StyledCard = styled(Card)(({ theme }) => ({
  flexGrow: 1,
  backgroundColor: theme.palette.background.paper,
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  alignItems: "center",
}));

interface RuptureSetReportTabProps {
  fileId: string;
  metaAsString: string;
}

const RuptureSetReportTab: React.FC<RuptureSetReportTabProps> = ({
  fileId,
  metaAsString,
}: RuptureSetReportTabProps) => {
  const hash = "subsection-count";

  const reportUrl = buildUrl(REPORT_URL, {
    path: `/${fileId}/DiagnosticsReport/index.html`,
    hash: hash,
  });

  return (
    <StyledCard>
      <CardContent>
        <Typography gutterBottom variant="h5" component="h2">
          Rupture Set Diagnostics Report: {`${fileId}`}
        </Typography>
        <Typography variant="body2" color="textSecondary" component="p">
          {metaAsString}
        </Typography>
      </CardContent>
      <CardMedia
        sx={{ height: "80vh", padding: 0, borderColor: "#FAFAFA" }}
        src={reportUrl}
        title="DiagnosticsReport"
        component="iframe"
      />
    </StyledCard>
  );
};

export default RuptureSetReportTab;
